import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { PUBLIC_INTERNAL_API_HOST } from '../../utils/envVars';

const base = `${PUBLIC_INTERNAL_API_HOST}/vcards/file/`;

const getVcardFileUrl = (shopId) => {
  return `${base}${shopId}`;
};

getVcardFileUrl.propTypes = {
  shopId: PropTypes.number.isRequired,
};

const isVcardFileUrl = (url) => {
  return url && !isEmpty(url) && url.includes(base);
};

export default getVcardFileUrl;

export { isVcardFileUrl };
